module.exports = __webpack_public_path__ + "static/img/foundation-8m-x-2m_256.81821d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/foundation-8m-x-2m_256.png
// module id = A/Vx
// module chunks = 0